import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AdminIndex: React.FC = () => {
  return (
    <div>
      <h1>Admin Index</h1>
      <div className="row p-4">
        <Card className="col-md-4">
          <Card.Body>
            <Card.Title>Manage Subjects</Card.Title>
            <Card.Text>
              Add or remove subjects. Update subject's appearance on subject index page.
            </Card.Text>
            <Link to="subjects">Go to</Link>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}

export default AdminIndex;